module.exports = __webpack_public_path__ + "img/teaser_training9.fea1f77a.jpg";